// extracted by mini-css-extract-plugin
export default {"footer":"contact_footer__jQcK-","boxes":"contact_boxes__5GlR+","left":"contact_left__ay5jn","right":"contact_right__lkWpE"};